export default "__VITE_ASSET__e70d8185__"